import React, { FC, memo } from 'react';

import Typography from '@mui/material/Typography';

interface Props {
  className?: string;
}

const MaxFarms: FC<Props> = ({ className }) => (
  <Typography
    variant="caption1"
    color={(theme) => theme.secondary.s3}
    className={className}
  >
    You have selected the maximum number of items
  </Typography>
);

export default memo(MaxFarms);
